import 'core-js/stable'
import 'regenerator-runtime/runtime'

import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router/router'
import axios from 'axios'
import VuetifyConfirm from 'vuetify-confirm'
import VueMoment from 'vue-moment'
import InfiniteLoading from 'vue-infinite-loading'
import { TiptapVuetifyPlugin } from 'tiptap-vuetify'
import VueDragscroll from 'vue-dragscroll'
import Ads from 'vue-google-adsense'
import vueScript2 from 'vue-script2'
import { store } from "@/plugins/store"

import 'material-design-icons-iconfont/dist/material-design-icons.css'
import 'tiptap-vuetify/dist/main.css'
import 'vuetify/dist/vuetify.min.css'
import '@/assets/css/style.scss'

axios.defaults.baseURL = process.env.VUE_APP_BASE_URL_API;
axios.defaults.withCredentials = true;

Vue.config.productionTip = false

const vueInfiniteOption = {
  system: {
    throttleLimit: 50,
    loopCheckTimeout: 1000,
    loopCheckMaxCalls: 10,
  }, 
  slots: {
    noResults: '',
    noMore: '마지막 데이터예요',
  }
}


Vue.use(VuetifyConfirm, {vuetify})
Vue.use(VueMoment)
Vue.use(InfiniteLoading, vueInfiniteOption)
Vue.use(TiptapVuetifyPlugin, {
  vuetify,
  iconsGroup: 'md'
})
Vue.use(VueDragscroll)
// 에드센스
Vue.use(vueScript2)
Vue.use(Ads.Adsense)
Vue.use(Ads.InArticleAdsense)
Vue.use(Ads.InFeedAdsense)

new Vue({
  vuetify,
  router,
  store: store,
  render: h => h(App),
  // el: '#editorContainer'
}).$mount('#app')
